import { createSlice } from '@reduxjs/toolkit'
import { loadFormData } from 'apps/builder/store/actions/form'

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    name: 'test',
    id: '',
    builderVersion: '3',
    in_builder_3_experience: false,
  },
  reducers: {
    updateName(state, action) {
      return {
        ...state,
        name: action.payload,
      }
    },
    updateBuilderVersion(state, { payload }) {
      return {
        ...state,
        builderVersion: '2',
      }
    },
    updateOnSave(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        version: payload.version,
        status: 'pending',
        name: payload.name,
      }
    },
    updateOnPublish(state) {
      return {
        ...state,
        status: 'published',
      }
    },
  },
  extraReducers: {
    [loadFormData]: (state, action) => {
      const { app } = action.payload
      return app
    },
  },
})

const { actions, reducer } = appSlice

export const appActions = actions
export const appReducer = reducer
